module.exports = __webpack_public_path__ + "static/sun_satellite-feba0a24faef63d6cf8acab3945ce157.png";